package com.patronat.top.features.usermanagement.presentation

import com.patronat.top.core.base.ViewEvent
import com.patronat.top.core.base.ViewSideEffect
import com.patronat.top.core.base.ViewState
import com.patronat.top.core.domain.models.profiles.User
import com.patronat.top.dto.UserRole
import com.patronat.top.dto.UserStatus

data class UsersState(
    val users: List<User> = emptyList(),
    val totalCount: Long = 0,
    val currentPage: Int = 1,
    val pageSize: Int = 20,
    val isLoading: Boolean = false,
    val error: String? = null,
    val searchQuery: String = "",
    val selectedStatuses: List<UserStatus> = emptyList(),
    val selectedRoles: List<UserRole> = emptyList(),
    val targetRoles: List<UserRole> = emptyList(),
    val expandedMenuUser: User? = null
) : ViewState {
    val isEmpty: Boolean get() = users.isEmpty() && !isLoading && error == null && searchQuery.isEmpty() && selectedStatuses.isEmpty() && selectedRoles.isEmpty()
}

sealed interface UsersEvent : ViewEvent {
    data object OnAddUserClicked : UsersEvent
    data class OnLoadUsers(val roles: List<UserRole>) : UsersEvent
    data class OnSearch(val query: String) : UsersEvent
    data class OnFilterChanged(val statuses: List<UserStatus>) : UsersEvent
    data class OnRoleFilterChanged(val roles: List<UserRole>) : UsersEvent
    data class OnPageChanged(val page: Int) : UsersEvent
    data class OnPageSizeChanged(val pageSize: Int) : UsersEvent
    data class OnUserAction(val user: User) : UsersEvent
    data object OnDismissMenu : UsersEvent
    data class OnEditProfile(val user: User) : UsersEvent
    data class OnBlockUser(val user: User) : UsersEvent
    data class OnUnblockUser(val user: User) : UsersEvent
}

sealed interface UsersEffect : ViewSideEffect {
    data object NavigateToCreateUser : UsersEffect
    data class NavigateToEditUser(val userId: String) : UsersEffect
}